import type { RouteRecordRaw } from 'vue-router';
import StepPage from './pages/StepPage/StepPage.vue';
import StepsPage from './pages/StepsPage/StepsPage.vue';

export const main: RouteRecordRaw[] = [
  {
    name: 'steps',
    path: 'steps',
    component: StepsPage,
    meta: {
      requiresAuth: true,
      headerTitle: 'STEPS',
    },
  },
  {
    name: 'step.drill',
    path: 'step/:userStepId/:stepDocId',
    props: true,
    component: StepPage,
    meta: {
      requiresAuth: true,
      headerTitle: 'STEP_DRILL',
    },
  },
];

// export const base: RouteRecordRaw[] = []
